
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { City } from "../pages/master/city";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Headers, Http } from "@angular/http";

@Injectable()
export class VernostServiceService {
  //http://localhost:8086
  // http://localhost:8086
  localurl: any = "http://localhost:8080";
  url = window["omsubconfig"].backOffice + "/";
  businessUrl = window["omsubconfig"].businessurl;
  connectorUrl = window["omsubconfig"].connectorurl;
  
  daourl = window["omsubconfig"].daourl;
  // url: any = "http://localhost:8086/";
  constructor(private http: HttpClient, private _http: Http) {}
  //fetchAll
  private insertsingle_url: string = "" + this.url + "" + "insert"; //insertchild
  private getFareProductsDate_url: string =
    "" + this.url + "" + "getfareproductsdate";

  private UpdateTpmFee_url: string = "" + this.url + "" + "UpdateTpmFee_url";
  private InsertTpmFee_url: string = "" + this.url + "" + "SaveTpmFee";

  private fetchAll_url: string = "" + this.url + "" + "fetchAll";
  private AddPaxOmsurl: string = "" + this.url + "" + "AddPaxOms";
  private AddNoteOmsurl: string = "" + this.url + "" + "AddNoteOms";
  private submitFareFamilyurl: string = "" + this.url + "" + "submitFareFamily";
  private searchFareFamilyurl: string = "" + this.url + "" + "searchFareFamily";

  private updateFareFamilyurl: string = "" + this.url + "" + "updateFareFamily";

  private updateSettlementStatusurl: string =
    "" + this.url + "" + "updateSettlementStatus";
  private updateMilesConfigureurl: string =
    "" + this.url + "" + "updateMilesConfigure";

  private insert_url: string = "" + this.url + "" + "insertTableData";
  
  private uploadConvData_url: string = "" + this.url + "" + "uploadConvData";
  private insertConv_url: string = "" + this.url + "" + "insert_Conv_Fee_Tpm";
  private editConv_url: string = "" + this.url + "" + "edit_Conv_Fee_Tpm";
  
  private searchConv_url: string = "" + this.url + "" + "search_Conv_Fee_Tpm";
  
  private search_url: string = "" + this.url + "" + "searchRecords";
  private searchRecords_Countryurl: string =
    "" + this.url + "" + "searchRecords_Country";

  private searchRoleRecords_url: string =
    "" + this.url + "" + "searchRoleRecords";

  private searchRecords_CITY_URL: string =
    "" + this.url + "" + "searchRecords_CITY";
  private getFareProductsEditDate_url: string =
    "" + this.url + "" + "getfareproductseditdate";
  private combodata_url: string = "" + this.url + "" + "combodata";
  private combodata_url1: string = "" + this.url + "" + "combodata1";
  private combodata_url2: string = "" + this.url + "" + "combodata2";
  private checkboxdata_url: string = "" + this.url + "" + "checkbox";
  private featproduct_url: string = "" + this.url + "" + "insertfearproduct";
  //private role_url:string=""+this.url+""+"insert";insertfunctionality
  private role_url: string = "" + this.url + "" + "insertfunctionality";
  private allsupplier_url: string = "" + this.url + "" + "getAll";
  private updates_url: string = "" + this.url + "" + "update";
  private deleteUser_url: string = "" + this.url + "" + "deleteUser";
  private updateRPM: string = "" + this.url + "" + "updateRPM";
  private updateFareProduct: string = "" + this.url + "" + "updateFareProduct";
  private currency_url: string = "" + this.url + "" + "currency";
  // private supplier_url: string = "" + this.url + "" + "getSupplierId";
  private product_url: string = "" + this.url + "" + "getProduct";
  private insertformdatas: string = "" + this.url + "" + "insertFormData1";
  private sortOrder_url: string = "" + this.url + "" + "sortOrder";
  private saveCredField: string = "" + this.url + "" + "saveCredField";
  private insertuser_url: string = "" + this.url + "" + "insertuser";
  private login_url: string = "" + this.url + "" + "login";
  private loginuser_url: string = "" + this.url + "" + "loginuser";
  private loginsession_url: string = "" + this.url + "" + "loginsession";
  private insertmaster_url: string = "" + this.url + "" + "insertmaster";
  private editstatus_url: string = "" + this.url + "" + "editStatus";
  private getDuplicates_url: string = "" + this.url + "" + "duplicates";
  private checkexistyrl: string = "" + this.url + "" + "checkexist";
  private getAllFunctionality: string =
    "" + this.url + "" + "getAllFunctionality";
  private csvAdd: string = "" + this.url + "" + "insertCsvData";
  private getData_url: string = "" + this.url + "" + "showData";
  private getSupplierData_url: string = "" + this.url + "" + "showSupplierData";
  private updateRoleData1: string = "" + this.url + "" + "updateRoleData";
  private aprove_url: string = "" + this.url + "" + "insertAprove";
  private aprovalstatus_url: string = "" + this.url + "" + "aproveStatus";
  private funAccess_url: string = "" + this.url + "" + "funaccess";
  private city_url: string = "" + this.url + "" + "city";
  private getFieldList1: string = "" + this.url + "" + "getFieldList";
  private csvAddData: string = "" + this.url + "" + "insertCsvInformation";
  private submitMilesConfigureurl: string =
    "" + this.url + "" + "submitMilesConfigure";

  // private searchEconomyFareProduct_url: string =
  //   "" + this.url + "" + "getEconomyFareProduct";
  // private searchBuisnessFareProduct_url: string =
  //   "" + this.url + "" + "getBuisnessFareProduct";
  private searchFareProducts_url3: string = "" + this.url + "" + "abc3";
  
  private updateBookerEmail_Url: string = "" + this.url + "" + "updateBookerEmail";

  private TBOOrder_Url: string = "" + this.url + "" + "generateTBO";
  private get_TBO_Details_url : string = "" + this.url + "" + "getTBODetails"

  private supplierupdates_url: string = "" + this.url + "" + "editSupplier";
  private validator_url: string = "" + this.url + "" + "getValidator";
  private changeSTATUS_url: string = "" + this.url + "" + "changeSTATUS";

  private getAirlines_url: string = "" + this.url + "" + "getairlines";
  private updateSeourl: string = "" + this.url + "" + "updateSeo";

  private getExcAirlines_url: string =
    "" + this.url + "" + "getexclusionairlines";
  // private supplierInfo_url: string = "" + this.url + "" + "getSupplierId";
  private insert_airline_url: string = "" + this.url + "" + "insertairlinedata";
  private delete_airline_url: string = "" + this.url + "" + "deleteairlinedata";
  private getDataAirlinExurl: string = "" + this.url + "" + "getDataAirlinEx";
  private editAirlineDataurl: string = "" + this.url + "" + "editAirlineData";
  
  private getReconcileDataurl: string = "" + this.url + "" + "getReconcileData";
  private getUploadedDataurl: string = "" + this.url + "" + "getUploadedData";
  private insertUserTempurl: string = "" + this.url + "" + "insertUserTemp";
  private updateReconcileDataurl: string =
    "" + this.url + "" + "updateReconcileData";

  private insertReconcilationurl: string =
    "" + this.url + "" + "insertReconcilation";

  private uploadCurrency_url: string = "" + this.url + "" + "uploadCurrency";
  private saveOnApprovedurl: string = "" + this.url + "" + "saveOnApproved";

  private getBenefitUrl: string = "" + this.url + "" + "getTBOBenefit";
  private getuploadedStatusurl: string =
    "" + this.url + "" + "getuploadedStatus";

  //insertuser   loginUser

  //********** */
  private forgotpasswordurl: string = "" + this.url + "" + "forgotpassword";
  private changepassurl: string = "" + this.url + "" + "changepassword";
  private STATUS_url: string = "" + this.url + "" + "getSTATUS";


  private getCurrency1: string = "" + this.url + "" + "getCurrency";
  private getDropdowns: string = "" + this.url + "" + "getDropdowns";
  private getSource_Idurl: string = "" + this.url + "" + "getSource_Id";
  
  private searchRecordByIdUrl: string = "" + this.url + "" + "SearchRecordById";
  private searchRecordSupplierurl: string =
    "" + this.url + "" + "searchRecordSupplier";

  private changepassword_url: string = "" + this.url + "" + "resetpassword";
  private getsupplierProduct1: string =
    "" + this.url + "" + "getsupplierProduct";
  private getTierDate_url: string = "" + this.url + "" + "gettierdate";
  private getTierEditDate_url: string = "" + this.url + "" + "gettiereditdate";

  private updateurl: string = "" + this.url + "" + "updateData";
  private insertOffersurl: string = "" + this.url + "" + "insertOffers";
  private insertAncillarRuleUrl: string = ""+ this.url + "" + "insertAncillaries";
  private insertCobrandOffersurl: string = "" + this.url + "" + "insertCobrandOffers";
  private updateCobrandOffersurl: string = "" + this.url + "" + "updateCobrandOffers";
  
  private searchCobrandurl: string = "" + this.url + "" + "searchCobrand";
  
  
  private getOfferDiscountTypesurl: string = "" + this.url + "" + "getOfferDiscountTypes";
  
  private searchOffersurl: string = "" + this.url + "" + "searchOffers";
  private searchAncillariesRuleUrl: string = "" + this.url + "" + "searchAncillariesRule";
  private activateOffersurl: string = "" + this.url + "" + "activateOffers";
  private checkAncillaries: string = "" + this.url + "" + "checkAncillaries";
  
  private editOffersurl: string = "" + this.url + "" + "editOffers";
  private editAncillarRuleUrl: string = "" + this.url + "" + "editAncillaries";
  
  private search_url1: string = "" + this.url + "" + "mutipleSearchRecord";
  private getScreenDetailsurl = "" + this.url + "" + "getScreenDetails";
  private getShowFieldsUrl = "" + this.url + "" + "getShowFields";
  private updateRecordUrl = "" + this.url + "" + "updateRecord";
  private updateCred_Fieldurl = "" + this.url + "" + "updateCred_Field";
  private getSPDetailsurl = "" + this.url + "" + "getSPDetails";
  private getFieldList2 = "" + this.url + "" + "getFieldListUpdated";
  private search_url2: string = "" + this.url + "" + "mutipleSearchRecord1";
  private checkName_url: string = "" + this.url + "" + "checkName";
  private checkNameOffersurl: string = "" + this.url + "" + "checkNameOffers";
  



  private get_existing_booking: string = "" + this.url + "" + "existingbooking";
  private get_exceptionreport: string = "" + this.url + "" + "exceptionreport";
  private get_booking_details: string = "" + this.url + "" + "bookingdetails";
  private updateRegionurl: string = "" + this.url + "" + "updateRegion";
  private downloadCancelBookingurl: string =
    "" + this.url + "" + "downloadCancelBooking";
  private getCancelBookingurl: string = "" + this.url + "" + "getCancelBooking";
  private downloadEmailUrl : string = "" + this.url + "" + "downloadEmailBooking";

  private cancelFlightBookurl: string = "" + this.url + "" + "cancelFlight";
  private getSupplierLogsurl: string = "" + this.url + "" + "getSupplierLogs";
  private editcountryurl: string = "" + this.url + "" + "editcountry";


  private cancelHistoryFlightBookurl: string =
    "" + this.url + "" + "cancelHistoryFlight";

  private auto_search_city_url: string = "" + this.url + "" + "autoSearchCity"; 
  private auto_search_url: string = "" + this.url + "" + "autoSearchRecords";
  private country_url: string = "" + this.url + "" + "getCountry";
  
  private checkRecordNameurl: string = "" + this.url + "" + "checkRecordName";
  private insertSeourl: string = "" + this.url + "" + "insertSeo";
 
  private downloadFileurl: string = "" + this.url + "" + "downloadFile";

  private downloadFileReporturl: string =
    "" + this.url + "" + "RedeemFTRReport";
  private saveSettlmentsurl: string = "" + this.url + "" + "saveSettlments";

  private getPaiCharturl: string = "" + this.url + "" + "getPaiChart";
  private loggerInfourl: string = "" + this.url + "" + "loggerInfo";
  private readLogurl: string = "" + this.url + "" + "readLog";
  private getFareProductRecordurl: string =
    "" + this.url + "" + "getFareProductRecord";

  //********** */

  //*****22 Jan***** */

  //********** */
  private crisReedemption_url: string =
    "" + this.url + "" + "getCrisReedemptionData";
  private pgData_url: string = "" + this.url + "" + "getpgdata";
  // private get_pnr_data: string = "" + this.url + "" + "getpnrdata";
  private getdaoapp_url: string = "" + this.url + "" + "getdaoapp";
  private postdaoapp_url: string = "" + this.url + "" + "postdaoapp";
  private getbuisnessapp_url: string = "" + this.url + "" + "getbuisnessapp";
  private postbuisnessapp_url: string = "" + this.url + "" + "postbuisnessapp";

  private InsertTpmArray_url: string = "" + this.url + "" + "SaveTpmArray";
  private UpdateTpmArray_url: string = "" + this.url + "" + "UpdateTpmArray";
  private searchTpm_url: string = "" + this.url + "" + "searchTPMRecords";
  private downloadTPMFileurl: string = "" + this.url + "" + "downloadTPMFile";
  private downloadReporturl: string = "" + this.url + "" + "downloadReport";
  private DeleteTPMRecord_url: string = "" + this.url + "" + "DeleteTPMRecords";

  private searchFunctionalityRecord_url: string =
    "" + this.url + "" + "searchFunctionalityRecord";

  private UpdateCancelArray_url: string =
    "" + this.url + "" + "UpdateCancelArray";

  private InsertCancelArray_url: string =
    "" + this.url + "" + "SaveCancelArray";
  private DeleteCancelArray_url: string =
    "" + this.url + "" + "DeleteCancelArray";

  private DeleteInsuranceArray_url: string =
    "" + this.url + "" + "DeleteInsuranceArray";

  private combodata_url3: string = "" + this.url + "" + "combodata3";
  private combodata_url4: string = "" + this.url + "" + "combodata4";

  private InsertZoneArray_url: string = "" + this.url + "" + "SaveZoneArray";
  private UpdateZoneArray_url: string = "" + this.url + "" + "UpdateZoneArray";
  private downloadSampleurl: string = "" + this.url + "" + "downloadSample";
  private tpmMasterUrl: string = "" + this.url + "" + "insertTpm";

  private interational_TPM_MILES_url: string =
    "" + this.url + "" + "interational_TPM_MILES";
  private domestic_TPM_MILES_url: string =
    "" + this.url + "" + "domestic_TPM_MILES";
  private downloadSample_excel_d_url: string =
    "" + this.url + "" + "download_excel_d";
  private downloadSample_excel_I_url: string =
    "" + this.url + "" + "download_excel_I";
  private insertJp_url: string = "" + this.url + "" + "insertJpCal";
  private showXandY_url: string = "" + this.url + "" + "showXandY";
  private Upload_d_url: string = "" + this.url + "" + "Upload_Domestic_miles";
  private Upload_i_url: string =
    "" + this.url + "" + "Upload_International_miles";

  /** OfferId - Create, read, delete */
  private createOffer_url: string = "" + this.url + "" + "createOffers";
  private updateOffer_url: string = "" + this.url + "" + "updateOffers";
  private readOffer_url: string = "" + this.url + "" + "readOffers";
  private deleteOffer_url: string = "" + this.url + "" + "deleteOffers";
  private rzypaymidlist_url: string = "" + this.url + "" + "razorpaymidlist";
  private traveltypelist_url: string = "" + this.url + "" + "traveltypelist";
  /** Override - Create, read, delete */
  private searchPrice_url: string = "" + this.url + "" + "searchPrice";
  private createPrice_url: string = "" + this.url + "" + "createPrice";
  private readPrice_url: string = "" + this.url + "" + "readPrice";
  private readTpm_url: string = "" + this.url + "" + "readTpm";
  private deletePrice_url: string = "" + this.url + "" + "deletePrice";
  private updatePrice_url: string = "" + this.url + "" + "updatePrice";
  private get_ancillary_data_url: string = "" + this.url + "" + "getAncillaryDetailDB";
  private get_email_sent_status_url: string = "" + this.url + "" + "getEmailSentStatus";

  private updateanscisurl: string = "" + this.url + "" + "updateansci";
  private getBannerNames1: string = "" + this.url + "" + "getBannerNames";

  private cancelStatus_url:string = "" + this.url + "" + "CancelStatus";
  private crisPnrUpdate_url: string = "" + this.url + "" + "crisPnrUpdate";
  private creditShellUrl: string = "" + this.url + "" + "updatecreditShellCsv";
  private getCreditShellReport_url: string = "" + this.url + "" + "getCreditShellReport";
  private getDsrReportListUrl: string = "" + this.url + "" + "getDsrReportList";
  private downloadDsrUrl: string = "" + this.url + "" + "downloadDsr";
  private sendDsrEmail: string = "" + this.url + "" + "sendDsrEmail";
  private reloadHistory_url: string = "" + this.url + "" + "reloadHistory";
  private getAirlineData_url: string = "" + this.url + "" + "getAirlineData";
  private getSuppliers_url: string = "" + this.url + "" + "getSuppliers";
  private getPlatformData_url: string = "" + this.url + "" + "getPlatformData";
  private getFcrBookingUrl: string = "" + this.url + "" + "getFcrBookingData";
  private getRefundFtr_search_url: string = "" + this.url + "" + "getRefundSearchData";
  private getRefundFtr_download_url: string = "" + this.url + "" + "getRefundDownloadData";
  private getBanners: string = "" + this.url + "" + "searchBanners";
  
  //send lounge conformation api call
  private loungeTokenGeneration: string = "" + this.url + "" + "lounge_login";
  private sendLoungeConformationMail: string = "" + this.url + "" + "send_lounge_mail"

  CancelStatus(data){
    return this.http.post(this.cancelStatus_url,data);
  }
  crisPnrUpdate(data){
    return this.http.post(this.crisPnrUpdate_url, data);
  }
  
  searchfareproductRecord(data): Observable<City[]> {
    return this.http.post<City[]>(this.searchfareproduct_url, data);
  }
  Updatefareproduct1(data) {
    return this.http.post(this.Updatefareproduct_url1, data);
  }
  private Updatefareproduct_url1: string =
    "" + this.url + "" + "Updatefareproduct1";
  private Insertfareproduct_url: string =
    "" + this.url + "" + "Savefareproduct";
  Insertfareproduct(data) {
    return this.http.post(this.Insertfareproduct_url, data);
  }
  private searchfareproduct_url: string =
    "" + this.url + "" + "searchRecordsfareproduct";

  InsertZoneArray(data) {
    return this.http.post(this.InsertZoneArray_url, data);
  }
  UpdateZoneArray(data) {
    return this.http.post(this.UpdateZoneArray_url, data);
  }
  downloadSample() {
    return this.http.get(this.downloadSampleurl, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }


  downloadEmailBooking(data){
    return this.http.post(this.downloadEmailUrl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  getComboData3(data): Observable<City[]> {
    return this.http.post<City[]>(this.combodata_url3, data);
  }
  getComboData4(data): Observable<City[]> {
    return this.http.post<City[]>(this.combodata_url4, data);
  }

  UpdateCancelArray(data) {
    return this.http.post(this.UpdateCancelArray_url, data);
  }

  InsertCancelArray(data) {
    return this.http.post(this.InsertCancelArray_url, data);
  }

  DeleteCancelArray(data) {
    return this.http.post(this.DeleteCancelArray_url, data);
  }

  DeleteInsuranceArray(data) {
    return this.http.post(this.DeleteInsuranceArray_url, data);
  }

  searchFunctionalityRecord(data) {
    return this.http.post(this.searchFunctionalityRecord_url, data);
  }
  downloadReport(data) {
    return this.http.post(this.downloadReporturl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  DeleteTPMRecord(data) {
    return this.http.post(this.DeleteTPMRecord_url, data);
  }

  submitFareFamily(data) {
    return this.http.post(this.submitFareFamilyurl, data);
  }

  updateFareFamily(data) {
    return this.http.post(this.updateFareFamilyurl, data);
  }

  InsertTpmFee(data) {
    return this.http.post(this.InsertTpmFee_url, data);
  }

  UpdateTpmFee(data) {
    return this.http.post(this.UpdateTpmFee_url, data);
  }

  InsertTpmArray(data) {
    return this.http.post(this.InsertTpmArray_url, data);
  }

  UpdateTpmArray(data) {
    return this.http.post(this.UpdateTpmArray_url, data);
  }
  searchTPMRecord(data) {
    return this.http.post(this.searchTpm_url, data);
  }
  downloadTPMFile() {
    return this.http.get(this.downloadTPMFileurl, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  //*****22 Jan***** */
  // getPnrData(data) {
  //   return this.http.post(this.get_pnr_data, data);
  // }

  getPgData(data1) {
    return this.http.post(this.pgData_url, data1);
  }
  downloadPgData(data1) {
    return this.http.post(this.pgData_url, data1, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  getCrissReedemptionData(data1) {
    return this.http.post(this.crisReedemption_url, data1);
  }
  downloadCrissReedemptionData(data1) {
    return this.http.post(this.crisReedemption_url, data1, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  //*****22 Jan***** */

  //********** */

  getDupliactes() {
    return this.http.post(this.getDuplicates_url, "");
  }
  getFareProductRecord(data) {
    return this.http.post(this.getFareProductRecordurl, data);
  }

  editcountry(data1) {
    return this.http.post(this.editcountryurl, data1);
  }
  checkName(data1) {
    return this.http.post(this.checkName_url, data1);
  }
  checkNameOffers(data1) {
    return this.http.post(this.checkNameOffersurl, data1);
  }
  
  getFieldList(data1): Observable<City[]> {
    return this.http.post<City[]>(this.getFieldList1, data1);
  }

  updateRoleData(data) {
    return this.http.post(this.updateRoleData1, data);
  }
  getAllFuntionalityData(data) {
    return this.http.post(this.getAllFunctionality, data);
  }

  cityData(data): Observable<City[]> {
    return this.http.post<City[]>(this.city_url, data);
  }
  loginSession(data): Observable<City[]> {
    return this.http.post<City[]>(this.loginsession_url, data);
  }

  updateBookerEmail(data) {
    return this.http.post(this.updateBookerEmail_Url, data);
  }
  reloadHistory(data){
    return this.http.post(this.reloadHistory_url, data);
  }
  CreateTBOOrder(data) {
    return this.http.post(this.TBOOrder_Url, data);
  }

  get_TBO_Details(data) {
    return this.http.post(this.get_TBO_Details_url, data);
  }


  loginUser(data): Observable<City[]> {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("withCredentials", decodeURIComponent(document.cookie))
    return this._http.post(this.login_url, data,  { headers: headers }).pipe(
    map(res => res.json()));
  }

  loginUserData(data): Observable<City[]> {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("withCredentials", decodeURIComponent(document.cookie))
    return this._http.post(this.loginuser_url, data,  { headers: headers }).pipe(
    map(res => res.json()));
  }

  sortByOrder(data): Observable<City[]> {
    return this.http.post<City[]>(this.sortOrder_url, data);
  }
  aproveReject(data) {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this._http
      .post(this.aprove_url, data, { headers: headers }).pipe(
      map(res => res.json()));
  }
  checkAproval(data) {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this._http
      .post(this.aprovalstatus_url, data, { headers: headers }).pipe(
      map(res => res.json()));
  }
  insertCsvData(data) {
    var headers = new Headers();
    // console.log(data)
    // console.log("in cdx");
    headers.append("Content-Type", "application/json");
    return this._http
      .post(this.csvAdd, data, { headers: headers }).pipe(
      map(res => res.json()));
  }
  insertCsvInformation(data) {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this._http
      .post(this.csvAddData, data, { headers: headers }).pipe(
      map(res => res.json()));
  }
  insertUserData(data): Observable<City[]> {
    return this.http.post<City[]>(this.insertuser_url, data);
  }

  // getSupplier(): Observable<City[]> {
  //   return this.http.get<City[]>(this.supplier_url);
  // }
  getProduct(): Observable<City[]> {
    return this.http.get<City[]>(this.product_url);
  }
  checkFunAccess(data) {
    return this.http.post(this.funAccess_url, data);
  }

  save_Cred_Field(data): Observable<City[]> {
    return this.http.post<City[]>(this.saveCredField, data);
  }

  insertFormData1(data1): Observable<City[]> {
    return this.http.post<City[]>(this.insertformdatas, data1);
  }
  submitTpmMaster(data) {
    return this.http.post(this.tpmMasterUrl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  currencyData(data): Observable<City[]> {
    return this.http.post<City[]>(this.currency_url, data);
  }
  editData(data): Observable<City[]> {
    return this.http.post<City[]>(this.updates_url, data);
  }
  editFareProductData(data): Observable<City[]> {
    return this.http.post<City[]>(this.updateFareProduct, data);
  }
  editRPMData(data): Observable<City[]> {
    return this.http.post<City[]>(this.updateRPM, data);
  }
  editSupplierData(data) {
    return this.http.post(this.supplierupdates_url, data);
  }
  private sms_url: string = "" + this.url + "" + "sendsms";
  sendSms(data) {
    return this.http.post(this.sms_url, data);
  }

  getData(data): Observable<City[]> {
    return this.http.post<City[]>(this.getData_url, data);
  }
  getSupplierData(data) {
    return this.http.post(this.getSupplierData_url, data);
  }
  insertProductData(data): Observable<City[]> {
    return this.http.post<City[]>(this.featproduct_url, data);
  }

  insertRoleData(data): Observable<City[]> {
    return this.http.post<City[]>(this.role_url, data);
  }

  insertMasterData(data): Observable<City[]> {
    return this.http.post<City[]>(this.insertmaster_url, data);
  }
  insertData(data): Observable<City[]> {
    return this.http.post<City[]>(this.insert_url, data);
  }



  insertSingleTableData(data): Observable<City[]> {
    return this.http.post<City[]>(this.insertsingle_url, data);
  }

  searchRecord(data): Observable<City[]> {
    return this.http.post<City[]>(this.search_url, data);
  }

  searchRecords_Country(data): Observable<City[]> {
    return this.http.post<City[]>(this.searchRecords_Countryurl, data);
  }

  searchRoleRecord(data): Observable<City[]> {
    return this.http.post<City[]>(this.searchRoleRecords_url, data);
  }

  searchRecord_CITY(data): Observable<City[]> {
    return this.http.post<City[]>(this.searchRecords_CITY_URL, data);
  }

  getComboData(data): Observable<City[]> {
    return this.http.post<City[]>(this.combodata_url, data);
  }

  getComboData1(data): Observable<City[]> {
    return this.http.post<City[]>(this.combodata_url1, data);
  }
  getComboData2(data): Observable<City[]> {
    return this.http.post<City[]>(this.combodata_url2, data);
  }

  getCheckBoxData(data): Observable<City[]> {
    return this.http.post<City[]>(this.checkboxdata_url, data);
  }

  isCSVFile(file) {
    return file.name.endsWith(".csv");
  }

  getHeaderArray(csvRecordsArr, tokenDelimeter) {
    var headers = csvRecordsArr[0].split(tokenDelimeter);
    var headerArray = [];
    for (var j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  validateHeaders(origHeaders, fileHeaaders) {
    if (origHeaders.length != fileHeaaders.length) {
      return false;
    }

    var fileHeaderMatchFlag = true;
    for (var j = 0; j < origHeaders.length; j++) {
      if (origHeaders[j] != fileHeaaders[j]) {
        fileHeaderMatchFlag = false;
        break;
      }
    }
    return fileHeaderMatchFlag;
  }
  getDataRecordsArrayFromCSVFile(
    csvRecordsArray,
    headerLength,
    validateHeaderAndRecordLengthFlag,
    tokenDelimeter
  ) {
    var dataArr = [];

    for (var i = 0; i < csvRecordsArray.length; i++) {
      var data = csvRecordsArray[i].split(tokenDelimeter);
      var col = [];
      for (var j = 0; j < data.length; j++) {
        var str = data[j].split('"').join("");
        col.push(str);
      }
      dataArr.push(col);
    }
    return dataArr;
  }
  //********************* */
  getBannerNames() {
    return this.http.get(this.getBannerNames1);
  }
  //create credential
  getCurrency() {
    return this.http.get(this.getCurrency1);
  }

  

  getSource_Id() {
    return this.http.get(this.getSource_Idurl);
  }
  getDropdown() {
    return this.http.get(this.getDropdowns);
  }

  searchCobrand(data){
    return this.http.post(this.searchCobrandurl, data);
  }

  insertCobrandOffers(data){
    return this.http.post(this.insertCobrandOffersurl, data);
  }
  updateCobrandOffers(data){
    return this.http.post(this.updateCobrandOffersurl, data);
  }
  insertOffers(data) {
    return this.http.post(this.insertOffersurl, data);
  }

  insertAncillaries(data){
	  return this.http.post(this.insertAncillarRuleUrl,data);
  }

  getOfferDiscountTypes(data){
    return this.http.post(this.getOfferDiscountTypesurl, data);
  }
  
  

  editOffers(data) {
    return this.http.post(this.editOffersurl, data);
  }
  editAncillaries(data){
	return this.http.post(this.editAncillarRuleUrl,data);
}
  searchOffers(data) {
    return this.http.post(this.searchOffersurl, data);
  }

  searchAncillariesRule(data){
	return this.http.post(this.searchAncillariesRuleUrl, data);
  }
  
  checkAncillariesRule(data){
	return this.http.post(this.checkAncillaries, data);
  }

  activateOffers(data) {
    return this.http.post(this.activateOffersurl, data);
  }
  getsupplierProduct(data) {
    return this.http.post(this.getsupplierProduct1, data);
  }

  updateData(data) {
    return this.http.post(this.updateurl, data);
  }

  
  

  uploadConvData(data){
    return this.http.post(this.uploadConvData_url, data);
  }
  insertConvData(data){
    return this.http.post(this.insertConv_url, data);
  }
  editConvData(data){
    return this.http.post(this.editConv_url, data);
  }

  searchConvData(data){
    return this.http.post(this.searchConv_url, data);
  }

  mutipleSearchRecord(data) {
    return this.http.post(this.search_url1, data);
  }

  getScreenDetails(data) {
    return this.http.post(this.getScreenDetailsurl, data);
  }

  getShowFields(data) {
    return this.http.post(this.getShowFieldsUrl, data);
  }

  updateRecord(data) {
    return this.http.post(this.updateRecordUrl, data);
  }

  updateCred_Field(data) {
    return this.http.post(this.updateCred_Fieldurl, data);
  }

  getSPDetails(data) {
    return this.http.post(this.getSPDetailsurl, data);
  }

  mutipleSearchRecord1(data) {
    return this.http.post(this.search_url2, data);
  }

  getFieldListUpdated(data1) {
    return this.http.post(this.getFieldList2, data1);
  }

  // searchEconomyFareProduct(data) {
  //   return this.http.post(this.searchEconomyFareProduct_url, data);
  // }
  // searchBuisnessFareProduct(data) {
  //   return this.http.post(this.searchBuisnessFareProduct_url, data);
  // }
  searchFareProducts3(data) {
    return this.http.post(this.searchFareProducts_url3, data);
  }
  //***********************/

  getExistingBooking(data) {
    return this.http.post(this.get_existing_booking, data);
  }
  //***********************/

  forgotpassword(data) {
    // alert(JSON.stringify(data));
    return this.http.post(this.forgotpasswordurl, data);
  }

  changepassword(data) {
    return this.http.post(this.changepassurl, data);
  }
  searchRecordById(data) {
    return this.http.post(this.searchRecordByIdUrl, data);
  }

  getRecords(data) {
    return this.http.post(this.auto_search_url, data);

    //var ary=["latur","lahor","nanded","pune","mimbai","malad","pandarpur"]
  }

  getCityData(data) {
    return this.http.post(this.auto_search_city_url, data);
  }

  getValidator() {
    return this.http.get(this.validator_url);
  }

  editstatus(data) {
    return this.http.post(this.editstatus_url, data);
  }

  changeSTATUS(data) {
    return this.http.post(this.changeSTATUS_url, data);
  }
  getCountry(data) {
    return this.http.post(this.country_url, data);
  }
  getSTATUS(data) {
    return this.http.post(this.STATUS_url, data);
  }

  getAirlines(data): Observable<City[]> {
    return this.http.post<City[]>(this.getAirlines_url, data);
  }
  getExcAirline(data): Observable<City[]> {
    return this.http.post<City[]>(this.getExcAirlines_url, data);
  }
  // getSupplierInfo(): Observable<City[]> {
  //   return this.http.get<City[]>(this.supplierInfo_url);
  // }
  insertAirlineData(data) {
    return this.http.post(this.insert_airline_url, data);
  }
  deleteAirlineData(data): Observable<City[]> {
    return this.http.post<City[]>(this.delete_airline_url, data);
  }

  getBookingDetails(data) {
    return this.http.post(this.get_booking_details, data);
  }
  getCancelBooking(data) {
    return this.http.post(this.getCancelBookingurl, data);
  }

  getDsrReportList(data){
	return this.http.post(this.getDsrReportListUrl, data);
  }
  downloadDsr(req){
    return this.http.post(this.downloadDsrUrl, req, {
		responseType: "blob",
		headers: new HttpHeaders().append("Conent-type", "application/json")
	  });
  }
  sendDsrEmailReq(req){
	  return this.http.post(this.sendDsrEmail,req);
  }
  downloadCancelBooking(data) {
    return this.http.post(this.downloadCancelBookingurl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  getOrderDetails(path, data) {
    return this.http.post(this.daourl + path, data);
  }
  cancelFlightBooking(data) {
    return this.http.post(this.cancelFlightBookurl, data);
  }
  cancelHistoryFlightBooking(data) {
    return this.http.post(this.cancelHistoryFlightBookurl, data);
  }

  searchRecordSupplier(data): Observable<City[]> {
    return this.http.post<City[]>(this.searchRecordSupplierurl, data);
  }

  checkexist(data) {
    return this.http.post(this.checkexistyrl, data);
  }

  updateRegion(data) {
    return this.http.post(this.updateRegionurl, data);
  }

  getFareProductsDate(data): Observable<City[]> {
    return this.http.post<City[]>(this.getFareProductsDate_url, data);
  }
  getFareProductsEditDate(data): Observable<City[]> {
    return this.http.post<City[]>(this.getFareProductsEditDate_url, data);
  }

  
  ////new
  changePassWord(data) {
    //console.log("hrer");
    return this.http.post(this.changepassword_url, data);
  }

  checkRecordName(data) {
    return this.http.post(this.checkRecordNameurl, data);
  }

  getDataAirlinEx(data) {
    return this.http.post(this.getDataAirlinExurl, data);
  }
  editAirlineData(data) {
    return this.http.post(this.editAirlineDataurl, data);
  }
  getTierDate(data): Observable<City[]> {
    return this.http.post<City[]>(this.getTierDate_url, data);
  }
  getTierEditDate(data): Observable<City[]> {
    return this.http.post<City[]>(this.getTierEditDate_url, data);
  }

  insertSeo(data) {
    return this.http.post(this.insertSeourl, data);
  }


  getReconcileData(data) {
    return this.http.post(this.getReconcileDataurl, data);
  }
  getUploadedData(data) {
    return this.http.post(this.getUploadedDataurl, data);
  }
  updateReconcileData(data) {
    return this.http.post(this.updateReconcileDataurl, data);
  }
  insertReconcilation(data) {
    return this.http.post(this.insertReconcilationurl, data);
  }


  saveSettlments(data) {
    return this.http.post(this.saveSettlmentsurl, data);
  }

  updateSeo(data) {
    return this.http.post(this.updateSeourl, data);
  }
  getPaiStatus(data) {
    return this.http.post(this.getPaiCharturl, data);
  }

  downloadFile(file: string) {
    var body = { filename: file };

    return this.http.post(this.downloadFileurl, body, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  getDataApi(path) {
    // var projecturl = "http://54.205.227.164:8085";
    return this.http.get(this.url + path);
  }
  insertUserTemp(data) {
    return this.http.post(this.insertUserTempurl, data);
  }
 deleteUser(data): Observable<{ status: boolean; message: string }> {
  return this.http.post<{ status: boolean; message: string }>(this.deleteUser_url, data);
}
  DownloadReports(path, data) {
    return this.http.post("" + this.url + "" + path, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  downloadFileReport(data) {
    return this.http.post(this.downloadFileReporturl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  // uploadCurrency(data) {
  //   var headers = new Headers();
  //   // console.log(data)
  //   console.log("in cdx");
  //   headers.append("Content-Type", "application/json");
  //   return this._http
  //     .post(this.uploadCurrency_url, data, { headers: headers })
  //     .map(res => res.json());
  // }

  uploadCurrency(data) {
    return this.http.post(this.uploadCurrency_url, data);
  }

  getuploadedStatus() {
    return this.http.get(this.getuploadedStatusurl);
  }
  getJSON(path) {
    return this.http.get(this.url + path);
  }
  getBenefit(){
    return this.http.get(this.getBenefitUrl);
  }
  postBuisnessApi(path, data) {
    return this.http.post(this.businessUrl + path, data);
  }
  postConnectorApi(path, data) {
    return this.http.post(this.connectorUrl + path, data);
  }

  loggerInfo(data) {
    return this.http.post(this.loggerInfourl, data);
  }
  // postData(path, data) {
  //   //  console.log("this.url + path",this.url + path,"data",data);
  //   return this.http.post(this.url + path, data);
  // }

  postData(path, data) {
    //  console.log("this.url + path",this.url + path,"data",data);
    // var prod="https://flightsadmin.intermiles.com/Scheduler";
   return this.http.post(this.url + path, data);
  //  return this.http.post(prod, data);
  }
 

  get_dao_prize_check_req(path, data) {
    // console.log(this.dao_url+path,"*************reqqq**************",data);
    return this.http.post(this.daourl + path, data);
  }
  call_update_pnr_prize_check(path, data) {
    // console.log(this.dao_url+path,"*************reqqqprizecheck**************",data);
    return this.http.post(this.connectorUrl + path, data);
  }
  saveOnApproved(data) {
    return this.http.post(this.saveOnApprovedurl, data);
  }
  readLog(data) {
    return this.http.post(this.readLogurl, data);
  }

  AddPaxOms(data) {
    return this.http.post(this.AddPaxOmsurl, data);
  }

  AddNoteOms(data) {
    return this.http.post(this.AddNoteOmsurl, data);
  }

  submitMilesConfigure(data) {
    console.log("dataa=========>",data)
    return this.http.post(this.submitMilesConfigureurl, data);
  }
  searchFareFamily(data) {
    return this.http.post(this.searchFareFamilyurl, data);
  }

  updateMilesConfigure(data) {
    return this.http.post(this.updateMilesConfigureurl, data);
  }
  postDataDao(path, data) {
    return this.http.post(this.daourl + path, data);
  }

  updateSettlementStatus(data) {
    return this.http.post(this.updateSettlementStatusurl, data);
  }

  getDaoApp(data) {
    return this.http.post(this.getdaoapp_url, data);
  }
  postDaoApp(data) {
    return this.http.post(this.postdaoapp_url, data);
  }
  getBuisnessApp(url, data) {
    return this.http.post(this.getbuisnessapp_url, data);
  }
  postBuisnessApp(url, data) {
    return this.http.post(this.postbuisnessapp_url, data);
  }

  getSupplierLogs(data) {
    return this.http.post(this.getSupplierLogsurl, data);
  }

  submitmilescalc(data) {
    return this.http.post(this.insertJp_url, data);
  }

  interational_TPM_MILES(data) {
    return this.http.post(this.interational_TPM_MILES_url, data);
  }

  domestic_TPM_MILES(data) {
    return this.http.post(this.domestic_TPM_MILES_url, data);
  }

  downloadSample_excel_d() {
    return this.http.get(this.downloadSample_excel_d_url, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  downloadSample_excel_I() {
    return this.http.get(this.downloadSample_excel_I_url, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }

  showXandY() {
    return this.http.get(this.showXandY_url);
  }

  Upload_d_miles(data) {
    return this.http.post(this.Upload_d_url, data);
  }

  Upload_i_miles(data) {
    return this.http.post(this.Upload_i_url, data);
  }

  /** Create OfferId */
  createOffers = data => {
    return this.http.post(this.createOffer_url, data);
  };

  /** Update OfferId */
  updateOffers = data => {
    return this.http.post(this.updateOffer_url, data);
  };

  /** Read OfferId */
  getOfferList = data => {
    return this.http.post(this.readOffer_url, data);
  };

  /** Delete OfferId */
  deleteOffer = data => {
    return this.http.post(this.deleteOffer_url, data);
  };

  /**  rzypaymid list */
  rzypaymidlist() {
    return this.http.get(this.rzypaymidlist_url);
  }

  traveltypelist() {
    return this.http.get(this.traveltypelist_url);
  }

  /** Override - Create Price */
  createPrice = data => {
    return this.http.post(this.createPrice_url, data);
  };

  /** Override - search Price */
  searchPrice = data => {
    return this.http.post(this.searchPrice_url, data);
  };

  /** Override - Get all Price list */
  getPriceList(data) {
    return this.http.post(this.readPrice_url, data);
  }

  /** Override - Get TPM details */
  getTpmList = data => {
    return this.http.post(this.readTpm_url, data);
  };

  /** Override - Delete Price details */
  deletePrice = data => {
    return this.http.post(this.deletePrice_url, data);
  };

  /** Override - Update Price details */
  updatePrice = data => {
    return this.http.post(this.updatePrice_url, data);
  }; 

  
  getAncillaryData(data): Observable<City[]> {
    return this.http.post<City[]>(this.get_ancillary_data_url, data);
  }
  getEmailSentStatus(data): Observable<City[]> {
    return this.http.post<City[]>(this.get_email_sent_status_url, data);
  }
  editAnscilaries(data) {
    return this.http.post(this.updateanscisurl, data);
  }
  uploadCreditShellCSV(data){
    return this.http.post(this.creditShellUrl, data);
  }
  getCreditShellReport(data) {
    if(data.type == 'download'){
      return this.http.post(this.getCreditShellReport_url, data, {
        responseType: "blob",
        headers: new HttpHeaders().append("Conent-type", "application/json")
      });
    }else{
      return this.http.post(this.getCreditShellReport_url, data);
    }
  }


  getAirlineData(){
    return this.http.get(this.getAirlineData_url);
  }
  getSuppliers(){
    return this.http.get(this.getSuppliers_url);
  }
  getPlatformData(){
    return this.http.get(this.getPlatformData_url);
  }
  getDownloadCSV(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/csv',
        responseType : 'blob',
        Accept : 'application/csv',
      })
    };
    return this.http.get(this.url + path,httpOptions);
  }

  getFcrBooking(data){
    return this.http.post(this.getFcrBookingUrl , data)
  }

  downloadFcrBooking(data) {
    return this.http.post(this.getFcrBookingUrl, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Conent-type", "application/json")
    });
  }
  getBannerDetails(path) {
    return this.http.get(this.url + path);
  }
  searchBanner(data): Observable<City[]> {
    return this.http.post<City[]>(this.getBanners, data);
  }
  postBannerDetails(bannerDetails) {
    return this.http.post(this.url + 'postBanner', bannerDetails);
  }
  uploadBanner(file) {
    return this.http.post(this.url + 'images/upload', file);
  }

  getSearchFlights(data) {
    return this.http.post(this.connectorUrl + "/travone_search", data)
  }

  getRefundReportSearch(data) {
    return this.http.post(this.getRefundFtr_search_url , data)
  }

  getRefundReportDownload(data) {
    return this.http.post(this.getRefundFtr_download_url, data, {
      responseType: "blob",
      headers: new HttpHeaders().append("Content-type", "application/json")
    });
  }

  /* searchBanner(data){
    return this.http.post(this.getBanners, data);
  } */

  loungeConformationMail(data){
    return this.http.post(this.sendLoungeConformationMail, data);
  }

  loungeLogin(data){
    return this.http.post(this.loungeTokenGeneration, data);
  }
  getExceptionreport(data) {
    return this.http.post(this.get_exceptionreport, data);
  }
}
